
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import aoneteachingimage  from '../../../images/footerLinksImages/featuresimage/teachingExperience.jpg'
function AOneTeaching() {

    const keywords = [
        { title: "Interactive Learning Methods", summary: "Engage in dynamic, hands-on learning experiences designed to foster active participation and deeper understanding." },
        { title: "Experienced Instructors", summary: "Learn from industry professionals with years of teaching and practical experience to guide your educational journey." },
        { title: "Personalized Learning", summary: "Get tailored lessons that cater to your individual learning style, ensuring better retention and mastery of concepts." },
        { title: "Modern Learning Tools", summary: "Access cutting-edge tools and technology that enhance the learning process and improve student outcomes." },
        { title: "Flexible Learning Options", summary: "Choose from a variety of learning schedules, including online and offline options, to fit your lifestyle." },
        { title: "Comprehensive Curriculum", summary: "Benefit from a well-structured and thorough curriculum that covers all necessary topics in-depth." },
        { title: "Practical Experience", summary: "Gain real-world experience through projects, case studies, and simulations that prepare you for future challenges." },
        { title: "Collaborative Learning Environment", summary: "Participate in group discussions and teamwork, fostering a collaborative approach to solving problems." },
        { title: "Progress Tracking", summary: "Stay on top of your progress with regular assessments and feedback to help you continuously improve." },
        { title: "Supportive Learning Community", summary: "Join a network of motivated learners and mentors that provide ongoing support throughout your learning journey." },
      ];
      
    return (<>
        <Header />
       
        <BannerFooter
            title="A-One Teaching & Learning Experience"
            text="Our A-One Teaching & Learning Experience offers a transformative approach to mastering trading, the stock market, and web technologies. Through expert-led courses, practical insights, and hands-on sessions, we provide learners with the knowledge and skills necessary to succeed in these dynamic fields. In trading and the stock market, our learning experience equips you with essential strategies, analysis techniques, and risk management tools. In web technologies, we cover everything from front-end development to advanced backend programming. With a focus on real-world applications, our courses are designed to ensure that you are industry-ready."
            imageone={aoneteachingimage}
            imagetwo={aoneteachingimage}
        />
        <div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">A-One Teaching & Learning Experience</h2>
    <div className="accordion" id="learningAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#learningAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default AOneTeaching